var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.505 20.5c.637 0 1.162-.524 1.162-1.122v-7.733h7.67c.628 0 1.163-.515 1.163-1.14 0-.626-.535-1.15-1.163-1.15h-7.67V1.622c0-.607-.525-1.122-1.162-1.122-.647 0-1.172.515-1.172 1.122v7.733h-7.67c-.61 0-1.163.524-1.163 1.15s.553 1.14 1.163 1.14h7.67v7.733c0 .598.525 1.122 1.172 1.122"
  })));
};
export default SvgPlus;